// SAM-1309 (U18): what Upcoming and Past of Passes hold. The server matches a pass whose visit [start, end] overlaps
// the window (date_from / date_to, whole days), so:
//  - Upcoming: a pass that has not ended: its window starts today (a year ahead is the far end);
//  - Past: a pass that started before today, whatever its status (it was only the Checked Out ones before).
// A range the user picks in the date picker replaces the tab's window.
import { toDayParam } from '../../api/businessAccessCombined';

export type PassTab = 'upcoming' | 'past';

const dayOffset = (now: Date, days: number): Date => {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  d.setDate(d.getDate() + days);
  return d;
};

export const tabWindow = (tab: PassTab, now: Date = new Date()): { date_from?: string; date_to?: string } =>
  tab === 'past'
    ? { date_to: toDayParam(dayOffset(now, -1)) }
    : { date_from: toDayParam(dayOffset(now, 0)), date_to: toDayParam(dayOffset(now, 365)) };
